import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import ServiceCard from "@/components/ServiceCard";
import CTABand from "@/components/CTABand";
import api from "@/lib/api";

export default function Individuals() {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    api.get("/public/individuals").then((r) => setCards(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <Seo title="Individuals & Families | ApexPath UK Immigration"
        description="Support for individuals and families across UK immigration routes — family, visit, study, work, settlement and citizenship." />
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Individuals & Families" }]}
        eyebrow="Individuals & Families"
        title="Supporting You at" highlight="Every Stage"
        image="/images/ind-band.jpg"
        subtitle="We help individuals and families navigate the UK immigration system with clear, practical and compassionate support." />

      <section className="bg-white py-16">
        <div className="container-x">
          <h2 className="mb-2 font-serif text-3xl font-semibold text-navy">Choose the area you need help with</h2>
          <p className="mb-10 max-w-3xl text-base text-slate-600">
            We support individuals and families across every major UK immigration route — Family &amp; Partner,
            Visiting the UK, Studying, Working, Dependants, Settlement / ILR, British Citizenship and UK Ancestry.
            Select a category below to see how ApexPath can help; each one opens a dedicated page with the relevant
            service options.
          </p>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {cards.map((s) => <ServiceCard key={s.id} service={s} />)}
          </div>

          <div className="mt-10 flex flex-col items-start justify-between gap-5 rounded-xl border border-gold/30 bg-gold/5 p-7 md:flex-row md:items-center">
            <div className="flex items-start gap-4">
              <HelpCircle className="mt-1 shrink-0 text-gold" size={26} />
              <div>
                <h3 className="font-serif text-xl font-semibold text-navy">Not sure which route applies?</h3>
                <p className="mt-1 text-sm text-slate-600">Tell us your circumstances and we will help identify the next step.</p>
              </div>
            </div>
            <Link to="/book-consultation" data-testid="individuals-not-sure-cta" className="btn-gold shrink-0">
              Book a Consultation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
